/**
 * Tooltip
 */

// tslint:disable:no-submodule-imports

import 'tippy.js/dist/tippy.css';
import './styles.scss';

import Tippy, { TippyProps } from '@tippy.js/react';
import * as React from 'react';

import * as BEM from 'react-bem-helper';
import { Span } from '../Label';

interface TooltipProps extends Omit<TippyProps, 'size' | 'theme'> {
  className?: string;
  size?: LabelSize;
  theme?: 'white' | 'light' | 'dark' | 'black' | 'accent';
}

type TooltipContentProps = Pick<TooltipProps, 'content' | 'size'>;

const tooltipContentClasses = new BEM('tooltip-content');
const TooltipContent = ({ content, size = 'medium' }: TooltipContentProps) => {
  return typeof content === 'string' ? (
    <Span
      variant={size === 'large' ? 'description' : undefined}
      size={size}
      block
      {...tooltipContentClasses('', { [size!]: !!size })}
    >{content}
    </Span>
  ) : React.cloneElement(content, ({
    ...tooltipContentClasses('', { [size!]: !!size }, content.props.className),
  }));
};

export const Tooltip: React.SFC<TooltipProps> = ({ children, className, content, size, theme, ...rest }) => (
  <Tippy
    content={<TooltipContent content={content} size={size} />}
    theme={`ams-${theme || 'light'}`}
    animation="shift-toward"
    arrowType="round"
    arrow
    duration={[500, 250]}
    inertia
    performance
    {...rest}
  >
    {children}
  </Tippy>
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/text/Tooltip/index.tsx